var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.306,
    height: 18.295,
    viewBox: "0 0 18.306 18.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "home-icon",
    d: "M17.636,6.923,11.85,1.136a3.82,3.82,0,0,0-5.394,0L.67,6.923A2.272,2.272,0,0,0,0,8.54v7.488a2.288,2.288,0,0,0,2.288,2.288h13.73a2.288,2.288,0,0,0,2.288-2.288V8.54A2.272,2.272,0,0,0,17.636,6.923Zm-6.194,9.869H6.865v-3a2.288,2.288,0,0,1,4.577,0Zm5.339-.763a.763.763,0,0,1-.763.763H12.967v-3a3.814,3.814,0,0,0-7.628,0v3H2.288a.763.763,0,0,1-.763-.763V8.54A.769.769,0,0,1,1.749,8L7.535,2.217a2.294,2.294,0,0,1,3.237,0L16.557,8a.769.769,0,0,1,.223.537Z",
    transform: "translate(0 -0.021)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.ab7df08d71c708e519a9f6caeee0aed8.svg";
export { ForwardRef as ReactComponent };